/**
 * GEN-4162 — régua ÚNICA do módulo Credenciais no front (menu aberto e recolhido, busca do TopNav,
 * rota `/credenciais`, toggles de notificação e modal de acesso de usuários).
 *
 * Quem decide é o backend: `clients[].modules.credentials` do `/auth/validate`, derivado do catálogo
 * (algum produto ligado aceita credencial, opcional ou obrigatória, ou `products.credentials`). Antes
 * daqui cada tela tinha a sua cópia de uma lista fixa de produtos, e nenhuma CND entrava nela.
 *
 * Sem `modules` (backend anterior à GEN-4162, durante a janela de deploy) vale a lista antiga.
 */

/** Lista fixa anterior à GEN-4162 — só para quando o backend ainda não manda `modules`. */
const LEGACY_CREDENTIALS_PRODUCTS = ["credentials", "dte_federal", "dte_state", "dte_municipal"];

export interface ICredentialsModuleClient {
  products?: Record<string, unknown> | null;
  modules?: { credentials?: boolean } | null;
}

/** O cliente traz o módulo derivado do backend? */
export const hasDerivedCredentialsModule = (client: ICredentialsModuleClient | null | undefined): boolean =>
  typeof client?.modules?.credentials === "boolean";

/**
 * `hasTaxCurrentAccountProduct`: o módulo Conta Corrente com empresa cadastrada continua ligando o
 * Credenciais, como antes (o mesmo booleano que o `AppShell` deriva).
 */
export const hasCredentialsModule = (
  client: ICredentialsModuleClient | null | undefined,
  hasTaxCurrentAccountProduct = false
): boolean => {
  if (!client) return false;
  if (hasTaxCurrentAccountProduct) return true;
  if (hasDerivedCredentialsModule(client)) return Boolean(client.modules?.credentials);
  return LEGACY_CREDENTIALS_PRODUCTS.some((product) => Boolean(client.products?.[product]));
};
